var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60821",
    "data-name": "Group 60821",
    transform: "translate(-12702 -12933)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(12702 12933)",
    fill: "#2280fc",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(12710 12941)",
    fill: "#2280fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_0fb02fdbc618362b35afb01678d1160d",
    "data-name": "0fb02fdbc618362b35afb01678d1160d",
    transform: "translate(12724.516 12955.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24377",
    "data-name": "Path 24377",
    d: "M4.051,21.131a12.064,12.064,0,1,0,17.06-17.06,12.064,12.064,0,1,0-17.06,17.06ZM3.511,11.6h-.9A9.988,9.988,0,0,1,4.83,6.228l.679.639a1.019,1.019,0,0,0,.719.3,1.006,1.006,0,0,0,.7-1.718L6.288,4.81a9.988,9.988,0,0,1,5.334-2.217v.9a1,1,0,1,0,2,0v-.9A9.988,9.988,0,0,1,18.994,4.81l-.619.679a1,1,0,0,0,0,1.418.939.939,0,0,0,.7.3.979.979,0,0,0,.7-.3l.639-.639a9.868,9.868,0,0,1,2.217,5.374H21.75a1,1,0,1,0,0,2h.879a9.868,9.868,0,0,1-2.217,5.374l-.639-.619a.989.989,0,0,0-1.4,1.4l.619.639a9.868,9.868,0,0,1-5.374,2.217V21.77a1,1,0,1,0-2,0v.879a9.868,9.868,0,0,1-5.374-2.217l.639-.639a.959.959,0,0,0,0-1.4,1,1,0,0,0-1.418,0l-.639.619A9.988,9.988,0,0,1,2.612,13.6h.9a1,1,0,1,0,0-2ZM50.917,50.857a11.986,11.986,0,0,0,0-17.06h0a12.106,12.106,0,0,0-17.06,0h0a12.064,12.064,0,1,0,17.06,17.06Zm-1.458-2.8a1,1,0,0,0-1.418,1.418l.639.639a9.989,9.989,0,0,1-5.374,2.217v-.9a1,1,0,0,0-2,0v.9a9.989,9.989,0,0,1-5.374-2.217l.619-.639a1,1,0,0,0,0-1.418.959.959,0,0,0-1.4,0l-.639.639A9.868,9.868,0,0,1,32.3,43.325h.9a1.019,1.019,0,0,0,1-1,1,1,0,0,0-1-1h-.9a9.868,9.868,0,0,1,2.217-5.374l.639.619a.98.98,0,0,0,.7.3.939.939,0,0,0,.7-.3.959.959,0,0,0,0-1.4l-.619-.639a9.868,9.868,0,0,1,5.374-2.217v.9a1,1,0,0,0,1,1,1.019,1.019,0,0,0,1-1v-.9a9.868,9.868,0,0,1,5.374,2.217l-.639.639a.959.959,0,0,0,0,1.4,1,1,0,0,0,.7.3,1.019,1.019,0,0,0,.719-.3l.639-.619a9.989,9.989,0,0,1,2.217,5.374h-.859a1,1,0,1,0,0,2h.9A9.989,9.989,0,0,1,50.138,48.7Zm-28.987,1.8a.979.979,0,0,0-.739-1.2A21.155,21.155,0,0,1,3.511,28.043a1,1,0,0,0-2,0A23.173,23.173,0,0,0,19.193,50.6h.3A1,1,0,0,0,20.472,49.858Z",
    transform: "translate(0 0.007)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24378",
    "data-name": "Path 24378",
    d: "M13.13,44.025a1,1,0,0,0-1.638,1.159L13.83,48.42l-3.236,2.3a1,1,0,0,0,.579,1.818,1.039,1.039,0,0,0,.579-.18l4.075-2.817a1,1,0,0,0,.24-1.4ZM24.917,3.173a1,1,0,0,0,.739,1.2A21.155,21.155,0,0,1,41.8,24.987a1,1,0,0,0,2,0A23.173,23.173,0,0,0,26.135,2.433,1.019,1.019,0,0,0,24.917,3.173Z",
    transform: "translate(9.659 1.904)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24379",
    "data-name": "Path 24379",
    d: "M28.263,9.492a1.039,1.039,0,0,0,.579-.18,1,1,0,0,0,.24-1.4l-2.3-3.3,3.236-2.3A1,1,0,0,0,28.863.682L24.807,3.5a1.019,1.019,0,0,0-.24,1.4l2.9,4A.959.959,0,0,0,28.263,9.492ZM7.807,14.606h-1.5a1.019,1.019,0,0,0-1,1,1,1,0,0,0,1,1h.5v.579a1,1,0,1,0,2,0v-.8a2.5,2.5,0,0,0-1-4.774.5.5,0,0,1,0-1h1.5a1,1,0,0,0,0-2h-.5V8.034a1,1,0,1,0-2,0v.8a2.5,2.5,0,0,0,1,4.774.5.5,0,0,1,0,1Zm31.4,24.152h.42a1,1,0,1,0,0-2h-.42A5.573,5.573,0,0,0,34.217,39.9h-.26a1.007,1.007,0,1,0-.26,2,3.787,3.787,0,0,0,0,.5,4,4,0,0,0,0,.479,1.007,1.007,0,1,0,.26,2h.26a5.594,5.594,0,0,0,4.994,3.136h.42a1,1,0,0,0,0-2h-.42a3.556,3.556,0,0,1-2.6-1.139h1.019a1,1,0,1,0,0-2h-2a3.585,3.585,0,0,1,0-.439,2.988,2.988,0,0,1,0-.439h2a1,1,0,1,0,0-2h-.979A3.555,3.555,0,0,1,39.211,38.758Z",
    transform: "translate(4.814 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchanger);
export default __webpack_public_path__ + "static/media/exchanger.ba605373d676708915b0543503a10b13.svg";
export { ForwardRef as ReactComponent };